module.exports = __webpack_public_path__ + "img/lens-160-minus-06.47458e53.png";